export default __webpack_public_path__ + "static/media/icdlquestionbank.c7675bab.svg";